import { List } from 'components/List';
import { useGet } from 'services/Http';

const columns = ['OID', 'Display Name', 'Configured?', 'LDD?', 'Payers'];
const columnWidths = [200, 250, 100, 80, 400];

export const ProductConfigList = () => {
    const productServices = useGet('/reference/product_benefit_configs/');

    return (
        <List
            pageTitle="Product Configurations"
            columnNames={columns}
            columnWidths={columnWidths}
            isLoading={!productServices}
            listData={productServices?.map((d) => [
                d.oid,
                d.description,
                d.configured ? 'Yes' : '',
                d.ldd ? 'Yes' : '',
                d.payer_segments,
            ])}
            editPath="/edit-product-config"
            createPath="/product-payer-config/bulk-upload"
            createButtonLabel="Bulk Upload Product Payer Config"
        />
    );
};
